import React, { useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Input, Select } from '~/components/Form';
import { t } from '~/helpers';
import {
  storeData,
  updateData,
} from '~/store/modules/pitStopJustificativa/actions';
import { MODULO_CUSTOMIZACAO_RUMO } from '~/constants/modules';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const { client } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector(
    (state) => state.pitStopJustificativa
  );

  const initials = create ? data : { ...find, ...data };

  const modules = useSelector((state) => state.user.modules);
  const clienteRumo = modules.includes(MODULO_CUSTOMIZACAO_RUMO);

  const handleSubmit = useCallback(
    async (param) => {
      try {
        const schema = Yup.object().shape({
          tipoatendimento: Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio')),
          descricaoobservacao: Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(50, t('s.geral.validacao.tamanhomaximo').replace('%s', 50)),
        });

        await schema.validate(param, {
          abortEarly: false,
        });

        const objSend = {
          ...initials,
          ...param,
          idcliente: client,
        };

        if (create) {
          dispatch(storeData(objSend, params));
        } else {
          dispatch(updateData(objSend, params));
        }
      } catch (err) {
        const validationErrors = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });

          reference.current.setErrors(validationErrors);
        }
      }
    },
    [create, client, initials]
  );

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Select
            name="tipoatendimento"
            variant="outlined"
            size="small"
            label={t('s.cadastro.pitstop.atendimento')}
            options={
              clienteRumo
                ? [
                    // { value: '0', label: t('s.relatorio.geral.todos') },
                    {
                      value: '1',
                      label: t(
                        's.configuracao.produto.calculodensidadeproduto.diesel'
                      ),
                    },
                    { value: '2', label: t('s.geral.opcoes.lubrificante') },
                    { value: '3', label: t('s.cadastro.pitstop.areia') },
                    { value: '4', label: t('s.cadastro.pitstop.limpeza') },
                    { value: '5', label: t('s.cadastro.pitstop.banheiro') },
                  ]
                : [
                    {
                      value: '1',
                      label: t(
                        's.configuracao.produto.calculodensidadeproduto.diesel'
                      ),
                    },
                    { value: '2', label: t('s.geral.opcoes.lubrificante') },
                    { value: '3', label: t('s.cadastro.pitstop.areia') },
                    { value: '4', label: t('s.cadastro.pitstop.limpeza') },
                    { value: '6', label: t('s.cadastro.pitstop.agua') },
                  ]
            }
          />
          <Input
            name="descricaoobservacao"
            label={t('s.cadastro.operacao.descricaooperacao')}
          />
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
